"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_bootstrap_table_next_1 = __importDefault(require("react-bootstrap-table-next"));
const TableSkeleton_1 = __importDefault(require("../../AdminShared/TableSkeleton"));
const react_bootstrap_1 = require("react-bootstrap");
const Utils_1 = require("../../../../utils/Utils");
const option_api_1 = require("../../../../utils/api/option/option.api");
const ai_1 = require("react-icons/ai");
const md_1 = require("react-icons/md");
const OptionDetailsModal_1 = __importDefault(require("../modals/OptionDetailsModal"));
const UpdateOptionModal_1 = __importDefault(require("../modals/UpdateOptionModal"));
const ShowOptionButton = ({ item }) => {
    const [show, setShow] = (0, react_1.useState)(false);
    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("button", { className: "btn btn-action-modal-icon with-tooltip", "data-tooltip-content": "Voir", onClick: handleShow },
            react_1.default.createElement(ai_1.AiFillEye, null)),
        react_1.default.createElement(OptionDetailsModal_1.default, { show: show, handleClose: handleClose, option: item })));
};
const UpdateOptionButton = ({ item }) => {
    const [show, setShow] = (0, react_1.useState)(false);
    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("button", { className: "btn with-tooltip btn-action-icon-edit", "data-tooltip-content": "Modifier", onClick: handleShow },
            react_1.default.createElement(md_1.MdEdit, { className: "edit-action-icon" })),
        react_1.default.createElement(UpdateOptionModal_1.default, { show: show, handleClose: handleClose, option: item })));
};
function OptionsTable() {
    const { data = { data: [], total: 0 }, isLoading } = (0, option_api_1.useGetOptionListQuery)();
    const imageFormatter = (cell, row) => {
        var _a, _b, _c, _d, _e;
        return (react_1.default.createElement("div", { className: "content-formatter" }, (cell !== null && (!((_a = row === null || row === void 0 ? void 0 : row.key) === null || _a === void 0 ? void 0 : _a.endsWith('_text')) && !((_b = row === null || row === void 0 ? void 0 : row.key) === null || _b === void 0 ? void 0 : _b.endsWith('_text_long')) && !((_c = row === null || row === void 0 ? void 0 : row.key) === null || _c === void 0 ? void 0 : _c.endsWith('_name')))) ? (react_1.default.createElement("div", { className: "image-container" }, ((_d = row === null || row === void 0 ? void 0 : row.key) === null || _d === void 0 ? void 0 : _d.endsWith('_image')) && (row === null || row === void 0 ? void 0 : row.image_value) !== null &&
            react_1.default.createElement("img", { src: row === null || row === void 0 ? void 0 : row.image_value, className: "rounded img-thumbnail w-50", alt: "..." }))) : (!((_e = row === null || row === void 0 ? void 0 : row.key) === null || _e === void 0 ? void 0 : _e.endsWith('_image'))) ? (react_1.default.createElement(react_bootstrap_1.Badge, { bg: "danger" }, "\u00C0 ne pas renseigner")) : (react_1.default.createElement(react_bootstrap_1.Badge, { bg: "warning" }, "Non renseign\u00E9"))));
    };
    const labelAndcontentFormatter = (cell, row) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        return (react_1.default.createElement("div", { className: "label-and-content" },
            react_1.default.createElement("p", { className: "m-0 pb-3" },
                react_1.default.createElement("strong", null, cell)),
            react_1.default.createElement("div", { className: "content-formatter" }, (row === null || row === void 0 ? void 0 : row.value) !== null && !((_a = row === null || row === void 0 ? void 0 : row.key) === null || _a === void 0 ? void 0 : _a.endsWith('_image')) ? (((_b = row === null || row === void 0 ? void 0 : row.key) === null || _b === void 0 ? void 0 : _b.endsWith("_text_long")) ||
                ((_c = row === null || row === void 0 ? void 0 : row.key) === null || _c === void 0 ? void 0 : _c.endsWith('_textarea')) ? (react_1.default.createElement("p", { dangerouslySetInnerHTML: (0, Utils_1.createMarkup)(row === null || row === void 0 ? void 0 : row.value, true, 120) })) : (react_1.default.createElement("p", null, row === null || row === void 0 ? void 0 : row.value))) : (((_d = row === null || row === void 0 ? void 0 : row.key) === null || _d === void 0 ? void 0 : _d.endsWith('_text'))
                || ((_e = row === null || row === void 0 ? void 0 : row.key) === null || _e === void 0 ? void 0 : _e.endsWith('_text_long'))
                || ((_f = row === null || row === void 0 ? void 0 : row.key) === null || _f === void 0 ? void 0 : _f.endsWith('_name'))
                || ((_g = row === null || row === void 0 ? void 0 : row.key) === null || _g === void 0 ? void 0 : _g.endsWith('_link'))
                || ((_h = row === null || row === void 0 ? void 0 : row.key) === null || _h === void 0 ? void 0 : _h.endsWith('_date'))
                || ((_j = row === null || row === void 0 ? void 0 : row.key) === null || _j === void 0 ? void 0 : _j.endsWith('_email'))
                || ((_k = row === null || row === void 0 ? void 0 : row.key) === null || _k === void 0 ? void 0 : _k.endsWith('_address'))
                || ((_l = row === null || row === void 0 ? void 0 : row.key) === null || _l === void 0 ? void 0 : _l.endsWith('_phone'))) ? (react_1.default.createElement(react_bootstrap_1.Badge, { bg: "warning" }, "\u00C0 renseigner")) : ((_m = row === null || row === void 0 ? void 0 : row.key) === null || _m === void 0 ? void 0 : _m.endsWith('_image')) && (react_1.default.createElement(react_bootstrap_1.Badge, { bg: "danger" }, "\u00C0 ne pas renseigner")))));
    };
    const actionFormatter = (cell, row) => {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "table-actions-btn-container d-flex gap-3" },
                react_1.default.createElement("div", { className: "container-btn-action-icon-modal d-flex justify-content-center" },
                    react_1.default.createElement(UpdateOptionButton, { item: row })),
                react_1.default.createElement("div", { className: "container-btn-action-icon-modal d-flex justify-content-center" },
                    react_1.default.createElement(ShowOptionButton, { item: row })))));
    };
    const columns = [
        {
            dataField: "label",
            text: "Labels et contenus",
            headerStyle: () => {
                return { width: "800px", whiteSpace: "normal" };
            },
            formatter: labelAndcontentFormatter
        },
        {
            dataField: "image_value",
            text: "Contenu Image",
            formatter: imageFormatter,
            headerStyle: () => {
                return { width: "200px", whiteSpace: "normal" };
            },
        },
        {
            dataField: "id",
            text: "Actions",
            formatter: actionFormatter,
            headerStyle: () => {
                return { width: "100px", whiteSpace: "normal" };
            },
        },
    ];
    return (react_1.default.createElement("div", { className: "col-lg-12" },
        react_1.default.createElement("div", { className: "admin-table" },
            !!isLoading && react_1.default.createElement(TableSkeleton_1.default, { headers: columns }),
            !isLoading && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(react_bootstrap_table_next_1.default, { keyField: "id", data: data === null || data === void 0 ? void 0 : data.data, columns: columns, condensed: true, hover: true, wrapperClasses: "table-responsive admin-table", noDataIndication: () => (react_1.default.createElement("div", null, "Aucune donn\u00E9e trouv\u00E9e")) }))))));
}
exports.default = OptionsTable;
